module.exports = __webpack_public_path__ + "img/back-icon.e5e225ee.svg";